// Generated by LiveScript 1.6.0
var Instagram;
Instagram = require('./custom/instagram.js');
new Instagram;
require('./widgets').initAllWithin(document);
require('./controllers').initAllWithin(document);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGV4LmxzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBS0EsU0FBWSxDQUFBLENBQUEsQ0FBRSxRQUFRLHVCQUFBO0FBSXRCLElBQUk7QUFFSixRQUFRLFdBQUEsQ0FBZSxDQUFDLGNBQWdCLFFBQUE7QUFDeEMsUUFBUSxlQUFBLENBQWUsQ0FBQyxjQUFnQixRQUFBIiwic291cmNlc0NvbnRlbnQiOltudWxsXX0=

